// types.ts
export type ValidationFn = (value: any, allValues?: Record<string, any>) => boolean;

export interface ValidationRule {
  validate: ValidationFn;
  message: string;
}

// formValidator.ts
export class FormValidator {
  private errors: Record<string, string> = {};
  private validations: Record<string, Array<ValidationRule>> = {};

  addRule(fieldName: string, validate: ValidationFn, message: string): this {
    if (!this.validations[fieldName]) {
      this.validations[fieldName] = [];
    }
    this.validations[fieldName].push({ validate, message });
    return this;
  }

  validate(data: Record<string, any>): boolean {
    this.errors = {};
    let isValid = true;

    Object.entries(this.validations).forEach(([fieldName, rules]) => {
      for (const rule of rules) {
        if (!rule.validate(data[fieldName], data)) {
          this.errors[fieldName] = rule.message;
          isValid = false;
          break;
        }
      }
    });

    return isValid;
  }

  getErrors(): Record<string, string> {
    return this.errors;
  }

  getFieldError(fieldName: string): string | undefined {
    return this.errors[fieldName];
  }

  clearErrors(): void {
    this.errors = {};
  }
}

export const ValidationRules = {
  required: (value: any): boolean => {
    if (Array.isArray(value)) return value.length > 0;
    return value !== null && value !== undefined && value !== '';
  },

  email: (value: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  },

  minLength:
    (length: number): ValidationFn =>
    (value: string): boolean =>
      value.length >= length,

  maxLength:
    (length: number): ValidationFn =>
    (value: string): boolean =>
      value.length <= length,

  date: (value: string): boolean => {
    return !isNaN(Date.parse(value));
  },

  custom: (fn: ValidationFn): ValidationFn => fn,
};
